import { render, staticRenderFns } from "./CouponPackageIndex.vue?vue&type=template&id=4fe73297"
import script from "./CouponPackageIndex.vue?vue&type=script&lang=js"
export * from "./CouponPackageIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fe73297')) {
      api.createRecord('4fe73297', component.options)
    } else {
      api.reload('4fe73297', component.options)
    }
    module.hot.accept("./CouponPackageIndex.vue?vue&type=template&id=4fe73297", function () {
      api.rerender('4fe73297', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/couponPackage/CouponPackageIndex.vue"
export default component.exports